import { render } from "./InviteFriends.vue?vue&type=template&id=57f13262&scoped=true"
import script from "./InviteFriends.vue?vue&type=script&lang=js"
export * from "./InviteFriends.vue?vue&type=script&lang=js"

import "./InviteFriends.vue?vue&type=style&index=0&id=57f13262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f13262"]])

export default __exports__